<li
  [style.width.px]="tabWidth"
  tooltipPosition="top"
  showDelay="250"
  [life]="3000"
  [hideDelay]="250"
  pTooltip="{{ name }}{{ unsavedChanges.isTabDirty(id) ? ' - ' + ('menuBarDetails.unsavedChanges' | translate) : '' }}"
  #tab
  [ngClass]="[isActive ? 'active' : '', 'tab']"
  [class.unsaved]="unsavedChanges.isTabDirty(id)"
  draggable="true"
  role="tab"
  tabindex="0"
  [attr.aria-selected]="isActive"
  id="{{ id }}"
  (drop)="handleDrop($event)"
  (dragstart)="handleDragStart($event)"
  (dragend)="handleDragEnd($event)"
  (dragover)="handleDragOver($event)"
  (click)="setActive($event)"
  (keydown)="onKeydown($event)"
  (contextmenu)="openContextMenu($event)"
  (auxclick)="$event?.button === 1 ? handleRemove() : null">
  <div class="name" data-cy="tab-name" [attr.data-cy-tabName]="name">
    <span class="tab-icon {{ iconClass }}"></span>
    @if (unsavedChanges.isTabDirty(id)) {
      <span aria-hidden="true" class="tab-unsaved-dot" data-cy="tab-unsaved-dot"></span>
    }{{ isLoading ? ('tabUi.loading' | translate) : name }}
  </div>
  <div
    #removeBtn
    class="remove"
    role="button"
    [attr.aria-label]="'generic.close' | translate"
    (click)="handleRemove()"
    iuKeybinding
    iuKeybinding-code="menu-top.close-tab"
    [iuKeybinding-active]="true"
    [iuKeybinding-badge-active]="isActive"
    [iuKeybinding-behavior-function]="handleKeybind"
    [iuKeybinding-behavior-context]="this"
    data-cy="tab-close-icon"></div>
</li>
